import WGLLog from './logger';

// const readOptsFilter = (gl, filterStr) => {
//   if(!filterStr){ return gl.LINEAR; }
//   switch(filterStr){
//     case "LINEAR": return gl.LINEAR;
//     case "NEAREST": return gl.NEAREST;
//     default: return gl.LINEAR;
//   }
// };

// const readOptsWrap = (gl, wrapStr) => {
//   if(!wrapStr){ return gl.CLAMP_TO_EDGE; }
//   switch(wrapStr){
//     case "CLAMP": return gl.CLAMP_TO_EDGE;
//     case "REPEAT": return gl.REPEAT;
//     default: return gl.CLAMP_TO_EDGE;
//   }
// };

class WGLTexture {
  // TODO: opts = { width:num, height:num, depth:bool, filter[optional]:"LINEAR"|"NEAREST", wrap[optional]:"CLAMP"|"REPEAT" }
  constructor(gl, key, texW, texH) {
    // save properties
    this.key = key;
    this.texW = texW;
    this.texH = texH;
    this._initTexture(gl);

    this._log(`Created (${texW}x${texH})`);
  }

  _initTexture(gl) {
    const { texW, texH } = this;

    // render buffer
    const idDepth = gl.createRenderbuffer();

    gl.bindRenderbuffer(gl.RENDERBUFFER, idDepth);
    gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_COMPONENT16, texW, texH);

    // color texture
    const idColor = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, idColor);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texImage2D(
      gl.TEXTURE_2D,
      0,
      gl.RGBA,
      texW,
      texH,
      0,
      gl.RGBA,
      gl.UNSIGNED_BYTE,
      null,
    );
    gl.bindTexture(gl.TEXTURE_2D, null);

    this.idDepth = idDepth;
    this.idColor = idColor;

    this._log(`Created (${texW}x${texH})`);
  }

  _log(msg) {
    WGLLog.info('Texture', this.key, msg);
  }

  getWidth() {
    return this.texW;
  }

  getHeight() {
    return this.texH;
  }

  resize(gl, texW, texH) {
    this.free(gl);

    this.texW = texW;
    this.texH = texH;

    this._initTexture(gl);
  }

  bind(gl, texUnit) {
    const { idColor } = this;

    gl.activeTexture(gl.TEXTURE0 + texUnit);
    gl.bindTexture(gl.TEXTURE_2D, idColor);
  }

  unbind(gl, texUnit) {
    gl.activeTexture(gl.TEXTURE0 + texUnit);
    gl.bindTexture(gl.TEXTURE_2D, null);
  }

  setImage(gl, image) {
    const { idColor } = this;

    gl.bindTexture(gl.TEXTURE_2D, idColor);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
    gl.bindTexture(gl.TEXTURE_2D, null);
  }

  bindWrite(gl) {
    const { idDepth, idColor, texW, texH } = this;

    gl.framebufferRenderbuffer(
      gl.FRAMEBUFFER,
      gl.DEPTH_ATTACHMENT,
      gl.RENDERBUFFER,
      idDepth,
    );
    gl.framebufferTexture2D(
      gl.FRAMEBUFFER,
      gl.COLOR_ATTACHMENT0,
      gl.TEXTURE_2D,
      idColor,
      0,
    );

    const status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
    if (status !== gl.FRAMEBUFFER_COMPLETE) {
      let errstring;
      switch (status) {
        case gl.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
          errstring = 'INCOMPLETE_ATTACHMENT';
          break;
        case gl.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
          errstring = 'INCOMPLETE_DIMENSIONS';
          break;
        case gl.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
          errstring = 'INCOMPLETE_MISSING_ATTACHMENT';
          break;
        case gl.FRAMEBUFFER_UNSUPPORTED:
          errstring = 'UNSUPPORTED';
          break;
        default:
          errstring = `Value ${status}`;
      }
      throw new Error(`FBO status fail: ${errstring}.`);
    }

    gl.viewport(0, 0, texW, texH);
  }

  unbindWrite(gl) {
    gl.framebufferTexture2D(
      gl.FRAMEBUFFER,
      gl.COLOR_ATTACHMENT0,
      gl.TEXTURE_2D,
      null,
      0,
    );
    gl.framebufferRenderbuffer(
      gl.FRAMEBUFFER,
      gl.DEPTH_ATTACHMENT,
      gl.RENDERBUFFER,
      null,
    );
  }

  free(gl) {
    const { idDepth, idColor, texW, texH } = this;

    gl.deleteRenderbuffer(idDepth);
    gl.deleteTexture(idColor);

    this._log(`Deleted (${texW}x${texH})`);
  }
}

export default WGLTexture;
